import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Container, Card, CardBody, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";

import {
  formatDate,
  getRecords,
  saveRecords,
} from "../../../services/api.service.js";
import "react-toastify/dist/ReactToastify.css";
import { createPageData } from "./BOMFile.js";
import { basicFormData } from "./BOMFile.js";
import {
  formContentContainer,
  loaderOverlay,
} from "../../../Style/loaderOverly.js";
import { AvForm } from "availity-reactstrap-validation";
import { LoaderCreatePage } from "../../Loader/Loader.js";
const BOMView = () => {
  const breadcrumbItems = [];
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, headerName, getEndpoint } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [customerSelect, setCustomerSelect] = useState("");
  const [fetchedData, setFetchedData] = useState(null);
  const [isCustomerModelOpen, setIsCustomerModelOpen] = useState(false);
  const [companyName, setCompanyName] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData;
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
        },
      }));
    }
  }, [fetchedData]);

  const getEditData = async (id) => {
    console.log("initialPayload", initialPayload);

    try {
      let payload = {
        modelName: initialPayload?.modelName,
        moduleWhereCondition: { is_active: true },
        relations: [
          {
            module: "bom_masters",
            moduleAs: "bomMakeItem",
            isModuleWhereConditionRequired: true,
            subModule: "item_masters",
            subModuleAs: "buyItem",
            subSubModule: "uom_masters",
            subSubModuleAs: "uom",
          },
          {
            module: "uom_masters",
            moduleAs: "uom",
          },
          {
            module: "category_masters",
            moduleAs: "category",
          },
          {
            module: "user_masters",
            moduleAs: "createdBy",
          },
          {
            module: "user_masters",
            moduleAs: "updatedBy",
          },
        ],
      };
      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };
  console.log("formdata.inputData", formData.inputData.bomMakeItem);
  const filteredItems =
    formData?.inputData?.bomMakeItem?.filter((row) =>
      row?.buyItem?.item_code?.toLowerCase().includes(searchQuery.toLowerCase())
    ) || [];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>BOM Details</h5>
                          <Button
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col
                              md="6"
                              // className="border-end border-secondary p-3"
                            >
                              <p>
                                <strong>Item Code: </strong>
                                {formData?.inputData?.item_code || "-"}
                              </p>
                              <p>
                                <strong>Description: </strong>
                                {formData?.inputData?.description || "-"}
                              </p>
                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.is_active == true
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                            </Col>
                            {/* Second Section (Right Side) */}
                            {/* <Col md="6" className="p-3">
                             
                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.is_active == true
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                            </Col> */}
                          </Row>
                        </div>
                      </div>
                      <Row className="mt-4">
                        <div className="item-list-container">
                          <div className="d-flex justify-content-between align-items-center">
                            <h6 className="h-6-heading">Buy Item Details</h6>
                            <div className="app-search d-flex d-lg-inline mt-0 p-0">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control ps-5"
                                  placeholder="Search by item code..."
                                  value={searchQuery}
                                  onChange={(e) =>
                                    setSearchQuery(e.target.value)
                                  }
                                  style={{
                                    width: "13rem",
                                    padding: "8px 15px",
                                    borderRadius: "8px",
                                    borderColor: "#D2D2D2",
                                    outline: "none",
                                    transition: "all 0.3s ease",
                                    boxShadow: "none",
                                    marginRight: "0.5rem",
                                  }}
                                />
                                <span className="ri-search-line"></span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="table mt-2"
                            style={{
                              // overflow: "auto",
                              overflowX: "auto",
                              overflowY: "auto",
                              maxHeight: "500px",
                              width: "100%",
                              scrollBehavior: "smooth",
                              scrollbarWidth: "thin",
                              msOverflowStyle: "none",
                              zIndex: 0,
                            }}
                          >
                            <table className="table table-hover">
                              <thead
                                style={{
                                  backgroundColor: "#8AC1E8",
                                  position: "sticky",
                                  top: 0,
                                  backgroundColor: "#8AC1E8",
                                  borderBottom: "1px solid black",
                                }}
                              >
                                {" "}
                                <tr style={{ borderBottom: "1px solid black" }}>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Sr. No
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Item Code
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Item Desc{" "}
                                  </th>

                                  <th style={{ whiteSpace: "nowrap" }}>UOM</th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Quantity Per BOM
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Created Date
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {filteredItems?.filter((row) => row.is_active)
                                  .length > 0 ? (
                                  filteredItems
                                    .filter((row) => row.is_active)
                                    .map((row, index) => {
                                      if (!row.buyItem?.item_code) {
                                        return (
                                          <tr>
                                            <td
                                              colSpan="10"
                                              style={{ textAlign: "center" }}
                                            >
                                              No data available.
                                            </td>
                                          </tr>
                                        );
                                      }
                                      return (
                                        <React.Fragment key={id}>
                                          <tr>
                                            <td>{index + 1}</td>

                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "180px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "5px",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "nowrap",
                                                  cursor:
                                                    row?.item?.type == 1 &&
                                                    "pointer",
                                                }}
                                                title={
                                                  row?.buyItem?.item_code ||
                                                  "N/A"
                                                }
                                              >
                                                <span>
                                                  {row?.buyItem?.item_code ||
                                                    "N/A"}
                                                </span>
                                              </div>
                                            </td>

                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "180px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  WebkitLineClamp: 2,
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "normal",
                                                }}
                                                title={
                                                  row?.buyItem?.description ||
                                                  "N/A"
                                                }
                                              >
                                                {row?.buyItem?.description ||
                                                  "N/A"}
                                              </div>
                                            </td>

                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {row?.buyItem?.uom?.uom_name ||
                                                "N/A"}
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {parseFloat(row?.qty_per_item) ||
                                                0}
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {new Date(
                                                row?.createdAt
                                              ).toLocaleString("en-GB", {
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                              })}{" "}
                                            </td>
                                          </tr>
                                        </React.Fragment>
                                      );
                                    })
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="10"
                                      style={{ textAlign: "center" }}
                                    >
                                      No data available.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Row>
                    </AvForm>

                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default BOMView;
